import React, {useState} from 'react'
import {Swiper, SwiperSlide, useSwiper} from 'swiper/react'
import {Grid, Navigation, Pagination} from 'swiper'
import 'swiper/css/pagination'
import 'swiper/css/grid'
import Balancer from 'react-wrap-balancer'
import './personal.css'

import people1 from '../../../../images/education/people_1.png'
import people3 from '../../../../images/education/people_3.jpg'
import people4 from '../../../../images/education/people_4.png'
import people5 from '../../../../images/education/people_5.png'
import people6 from '../../../../images/education/people_6.png'
import styles from './styles.module.scss'

const PersonalGenerium = () => {
  const [swiper, setSwiper] = useState(null);
  const [indexSwiperElem, setIndexSwiperElem] = useState(0)

  return (
    <div className={styles.wrapper}>
      <div className={styles.wr1}>
        <div className={styles.left}>
          <div>
            <p className={styles.title}>Что говорят студенты о программе?</p>
          </div>
        </div>
        <div className={styles.right}>
          <div className='flex flex-col'>
            <p className={styles.title}>Студенты о Generium</p>
          </div>
        </div>
      </div>
      <div className={styles.wr2}>
        <div className={styles.left}>
          <div className={styles.preview_people}>
            {indexSwiperElem !== 0 ? (
              <>
                <div onClick={() => swiper.slideTo(0)}>
                  <img className='preview_people-slider-photo' src={people1} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 1 ? (
              <>
                <div onClick={() => swiper.slideTo(1)}>
                  <img className='preview_people-slider-photo' src={people3} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 2 ? (
              <>
                <div onClick={() => swiper.slideTo(2)}>
                  <img className='preview_people-slider-photo' src={people4} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 3 ? (
              <>
                <div onClick={() => swiper.slideTo(3)}>
                  <img className='preview_people-slider-photo' src={people5} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
            {indexSwiperElem !== 4 ? (
              <>
                <div onClick={() => swiper.slideTo(4)}>
                  <img className='preview_people-slider-photo' src={people6} alt='people' draggable='false'/>
                </div>
              </>
            ) : ''}
          </div>
          <div className={styles.preview_people_active}>
            {indexSwiperElem == 0 ? (
              <><img className='preview_people_active-slider-photo' src={people1} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 1 ? (
              <><img className='preview_people_active-slider-photo' src={people3} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 2 ? (
              <><img className='preview_people_active-slider-photo' src={people4} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 3 ? (
              <><img className='preview_people_active-slider-photo' src={people5} alt='people' draggable='false'/></>
            ) : ''}
            {indexSwiperElem == 4 ? (
              <><img className='preview_people_active-slider-photo' src={people6} alt='people' draggable='false'/></>
            ) : ''}
          </div>
        </div>
        <div className={styles.right}>
          <p className={styles.text2}>
            <Balancer ratio={0.50}>
              {indexSwiperElem === 0
                ? 'Программа Mabstudy дала мне и многим другим ребятам возможность посмотреть на свою будущую профессию еще до вступления в профессиональное сообщество и понять, что это то, что нужно. Больше всего понравилось отношение ко мне сотрудников компании – не попытки требовать всех знаний мира, а постепенное обучение всем нюансам, четкая постановка задач и разъяснение сложных моментов.'
                + '\n\n' +
                'В начале пути, после обучения основным навыкам, работа проходила в лаборатории Mabstudy, где мы часто проводили эксперименты самостоятельно, что дало прекрасное понимание того, как всё функционирует, научило самостоятельности, умению принимать решения и отвечать за них.'
                : indexSwiperElem === 1
                ? 'Я решила пойти на программу стажировки Generium, так как мечтала окунуться в биотехнологический процесс разработки препаратов, непосредственно на фармацевтическом предприятии, получить дополнительные практические навыки работы. Мне очень понравилось, как была организована стажировка – и рабочий процесс, и досуг. '
                + '\n\n' +
                'Я окончила бакалавриат в вузе, следующая ступень – получение степени магистра в МГУ им. М. В. Ломоносова по программе «Регенеративная биомедицина». Свою магистерскую диссертацию планирую выполнять на базе лаборатории Mabstudy. По окончании университета я бы хотела связать свою жизнь с этой областью и внести свой вклад в развитие будущего. Буду рада продолжить сотрудничество с компанией Generium.'
                : indexSwiperElem === 2
                ? 'Я долго не могла найти подходящую магистерскую программу и совершенно случайно, из поста в социальной сети, узнала о программе «Современные технологии в коммерческой биофармацевтике». Изучила профиль предлагаемых дисциплин, и это было как раз то, что я искала. Могу с уверенностью сказать, что ни разу не пожалела о своем выборе.'
                + '\n\n' +
                'Очень нравится профиль предлагаемых дисциплин, интересно слушать лекторов, так как они не только дают современные теоретические знания, но и рассказывают про свой опыт с практической точки зрения. Лаборатории хорошо оснащены, а научные сотрудники и руководители непременно помогут с любыми возникающими в ходе работы вопросами. А проживание на территории компании идеально для полного погружения в учебу и в область биотехнологии в целом.'
                : indexSwiperElem === 3
                ? 'Стажировка в одной из ведущих компаний нашей страны — это отличная возможность попробовать свои силы и начать строить карьеру в сфере биотехнологий. На данной программе с первых дней удается полностью погрузиться в рабочий процесс и освоить множество необходимых навыков под наставничеством высококвалифицированных специалистов в короткий срок.'
                + '\n\n' +
                'На мой взгляд, программа стажировок в Generium подходит всем студентам или выпускникам, которые хотят получить опыт работы, приобрести необходимые компетенции и также понять, в каком направлении двигаться дальше. По завершении программы я планирую только расширять свои знания и умения, которые помогут генерировать новые идеи в этой области.'
                : indexSwiperElem === 4
                ? 'Я проходила годовую стажировку в компании Generium для выполнения магистерского проекта, о ней я узнала из социальных сетей. Для меня этот шанс стал прекрасной возможностью окунуться в настоящий рабочий процесс, участвовать в командном решении реальных задач и применять теоретические знания на практике. Я считаю, что практические занятия в образовательном учреждении не позволяют набрать аналогичный практический опыт, как во время стажировки. Поэтому я настоятельно рекомендую интересоваться возможностями, которые предоставляет компания, для накопления ценного опыта еще в статусе студента.'
                : null}
            </Balancer>
          </p>
          <div className="slider_main_mod_pg">
            <Swiper
              spaceBetween={70}
              slidesPerView={1}
              navigation
              onSlideChange={swiper => setIndexSwiperElem(swiper.activeIndex)}
              pagination={{
                type: 'fraction'
              }}
              onSwiper={setSwiper}
              modules={[Pagination, Navigation]}
              breakpoints={{
              // 1537: {
              //   spaceBetween: 70,
              //   slidesPerView: 1
              // },
              // 1536: {
              //   spaceBetween: 70,
              //   slidesPerView: 4
              // },
              // 1440: {
              //   spaceBetween: 70,
              //   slidesPerView: 3.9
              // },
              // 1365: {
              //   spaceBetween: 70,
              //   slidesPerView: 3.6
              // },
              // 1025: {
              //   spaceBetween: 55,
              //   slidesPerView: 3.2
              // },
              // 769: {
              //   spaceBetween: 50,
              //   slidesPerView: 3
              // },
              640: {
                slidesPerView: 1,
                initialSlide: 0
              },
              480: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              },
              370: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              },
              320: {
                spaceBetween: 16,
                initialSlide: 0,
                slideToClickedSlide: true
              }
               }}
            >
              <SwiperSlide id='0' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people1} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Программа Mabstudy дала мне и многим другим ребятам возможность посмотреть на свою будущую профессию еще до вступления в профессиональное сообщество и понять, что это то, что нужно. Больше всего понравилось отношение ко мне сотрудников компании – не попытки требовать всех знаний мира, а постепенное обучение всем нюансам, четкая постановка задач и разъяснение сложных моментов.</p>
                    <p className={styles.text}>В начале пути, после обучения основным навыкам, работа проходила в лаборатории Mabstudy, где мы часто проводили эксперименты самостоятельно, что дало прекрасное понимание того, как всё функционирует, научило самостоятельности, умению принимать решения и отвечать за них.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='1' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people3} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я решила пойти на программу стажировки Generium, так как мечтала окунуться в биотехнологический процесс разработки препаратов, непосредственно на фармацевтическом предприятии, получить дополнительные практические навыки работы. Мне очень понравилось, как была организована стажировка – и рабочий процесс, и досуг.</p>
                    <p className={styles.text}>Я окончила бакалавриат в вузе, следующая ступень – получение степени магистра в МГУ им. М. В. Ломоносова по программе «Регенеративная биомедицина». Свою магистерскую диссертацию планирую выполнять на базе лаборатории Mabstudy. По окончании университета я бы хотела связать свою жизнь с этой областью и внести свой вклад в развитие будущего. Буду рада продолжить сотрудничество с компанией Generium.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='2' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people4} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я долго не могла найти подходящую магистерскую программу и совершенно случайно, из поста в социальной сети, узнала о программе «Современные технологии в коммерческой биофармацевтике». Изучила профиль предлагаемых дисциплин, и это было как раз то, что я искала. Могу с уверенностью сказать, что ни разу не пожалела о своем выборе.</p>
                    <p className={styles.text}>Очень нравится профиль предлагаемых дисциплин, интересно слушать лекторов, так как они не только дают современные теоретические знания, но и рассказывают про свой опыт с практической точки зрения. Лаборатории хорошо оснащены, а научные сотрудники и руководители непременно помогут с любыми возникающими в ходе работы вопросами. А проживание на территории компании идеально для полного погружения в учебу и в область биотехнологии в целом.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='3' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people5} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Стажировка в одной из ведущих компаний нашей страны — это отличная возможность попробовать свои силы и начать строить карьеру в сфере биотехнологий. На данной программе с первых дней удается полностью погрузиться в рабочий процесс и освоить множество необходимых навыков под наставничеством высококвалифицированных специалистов в короткий срок.</p>
                    <p className={styles.text}>На мой взгляд, программа стажировок в Generium подходит всем студентам или выпускникам, которые хотят получить опыт работы, приобрести необходимые компетенции и также понять, в каком направлении двигаться дальше. По завершении программы я планирую только расширять свои знания и умения, которые помогут генерировать новые идеи в этой области.</p>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide id='4' className='wrapper-item-slider-people'>
                <div>
                  <div className={styles.img}>
                    <img className='people-slider-photo' src={people6} alt='people' draggable='false'/>
                  </div>
                  <div className={styles.desc}>
                    <p className={styles.text}>Я проходила годовую стажировку в компании Generium для выполнения магистерского проекта, о ней я узнала из социальных сетей. Для меня этот шанс стал прекрасной возможностью окунуться в настоящий рабочий процесс, участвовать в командном решении реальных задач и применять теоретические знания на практике. Я считаю, что практические занятия в образовательном учреждении не позволяют набрать аналогичный практический опыт, как во время стажировки. Поэтому я настоятельно рекомендую интересоваться возможностями, которые предоставляет компания, для накопления ценного опыта еще в статусе студента.</p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <p className={styles.text_b}>
          {indexSwiperElem === 0 ? (
            <>
              <p>Елена, РТУ МИРЭА, институт тонких химических технологий им. М.&nbsp;В.&nbsp;Ломоносова</p>
            </>
          ) : indexSwiperElem === 1 ? (
            <>
              <p>Дарья, Первый Московский государственный медицинский университет имени И.&nbsp;М.&nbsp;Сеченова</p>
            </>
          ) : indexSwiperElem === 2 ? (
            <>
              <p>Кристина, МФТИ</p>
            </>
          ) : indexSwiperElem === 3 ? (
            <>
              <p>Дарья, МФТИ</p>
            </>
          ) : indexSwiperElem === 4 ? (
            <>
              <p>Анастасия, БФУ им. Канта</p>
            </>
          ) : (
            <>
            <p>Елена, РТУ МИРЭА, институт тонких химических технологий им. М.&nbsp;В.&nbsp;Ломоносова</p>
          </>
          )}
          </p>
        </div>
      </div>
    </div>
  )
}

export default PersonalGenerium
